
   export const  convertPersianToEnglishDigits =(value)=> {
        const persianDigits = {
          '۰': '0',
          '۱': '1',
          '۲': '2',
          '۳': '3',
          '۴': '4',
          '۵': '5',
          '۶': '6',
          '۷': '7',
          '۸': '8',
          '۹': '9',
        };
      
        return value.replace(/[\u06F0-\u06F9]/g, (digit) => persianDigits[digit]);
      }
